import type { Workspace } from '@blocksuite/affine/store';

import type { DocsService } from '../../../doc';
import { hasMaterializedLocalDatabaseDoc } from '../../../doc/services/database-system-doc-access';
import type { DatabaseDiscoveryService } from '../../services/database-discovery';
import type {
  PreFlightDatabaseDirectories,
  PreFlightLocalDocs,
} from './preflight-comparison';

/** The preflight's view of the documents this client holds. */
export function preFlightLocalDocs(workspace: {
  id: string;
  docCollection: Workspace;
}): PreFlightLocalDocs {
  return {
    workspaceId: workspace.id,
    hasMaterializedDoc: docId =>
      hasMaterializedLocalDatabaseDoc(workspace.docCollection, docId),
  };
}

/** The preflight's view of the stored database directories. */
export function preFlightDatabaseDirectories(
  databases: Pick<DatabaseDiscoveryService, 'readDatabaseDirectoryDocIds'>,
  docs: Pick<DocsService, 'waitForServerConfirmed'>
): PreFlightDatabaseDirectories {
  return {
    read: ref =>
      ref.docId
        ? databases.readDatabaseDirectoryDocIds(ref.docId, ref.tableId)
        : undefined,
    waitForServerConfirmed: docId => docs.waitForServerConfirmed(docId),
  };
}
